module.exports = __webpack_public_path__ + "media/logos/logo-twitch-06189df1.svg";